export const touchable = () => {
    /* タッチデバイス判定 */
    let result = false;
    if (window.ontouchstart === null) {
        result = true;
    } 
    return result;
}